/**
 * External dependencies
 */
import { ImageUploadPlaceholder, BackgroundSettings, DesignPanelBody, BlockContainer } from '~cartzillagb/components'
import { withTabbedInspector } from '~cartzillagb/higher-order'
import classnames from 'classnames'
import {
	getAttrName,
	createButtonAttributeNames,
	createResponsiveAttributeNames,
	createTypographyAttributeNames,
	range,
} from '~cartzillagb/util'
import { i18n } from 'cartzillagb'

/**
 * Internal dependencies
 */

import ImageDesignBasic from './images/basic.png'
import ImageDesignPlain from './images/plain.png'

/**
 * WordPress dependencies
 */
import {
	PanelBody, ToggleControl, RangeControl 
} from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { RichText } from '@wordpress/block-editor'
import { addFilter, applyFilters } from '@wordpress/hooks'
import {
	Fragment,
	useState,
	useEffect, 
	useRef
} from '@wordpress/element'
import { compose } from '@wordpress/compose'
import $ from 'jquery'

addFilter( 'cartzillagb.review-carousel.edit.inspector.style.before', 'cartzillagb/review-carousel', ( output, props ) => {
	const { 
		attributes, 
		setAttributes,
		clientId,
	} = props

	const {
		blockId,
		postsToShow,
		displayAuthorImage,
		displayAuthorName,
		displayReviewDate,
		enableContainer,
		displaySectionHeader,
		displayStarRatings,
		postperslide,
		backgroundColor,
		background,
		design,
		slidesToScroll,
		displayboxShadow,

	} = attributes

	const postsToShowUpdate = ( postsToShow ) => {
		if ( $( `#${blockId}` ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( `#${blockId}` ).find( '.js-slick-carousel.slick-initialized' ).slick( 'unslick' )
		} else if ( $( `#${clientId}` ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( `#${clientId}` ).find( '.js-slick-carousel.slick-initialized' ).slick( 'unslick' )
		}

		setAttributes( { postsToShow: postsToShow } )
	}

	return (
		<Fragment>
			<DesignPanelBody
				initialOpen={ true }
				selected={ design }
				options={ applyFilters( 'cartzillagb.icon-blocks.edit.layouts', [
					{
						label: __( 'Style - 1', i18n ), value: 'style-1', image: ImageDesignBasic,
					},
					{
						label: __( 'Style - 2', i18n ), value: 'style-2', image: ImageDesignPlain,
					},
				] ) }
				onChange={ design => setAttributes( { design } ) }
			>
			</DesignPanelBody>
			<PanelBody title={ __( 'Review Settings', i18n ) } initialOpen={ true }>
				<RangeControl
					label={ __( 'Number of posts', i18n ) }
					value={ postsToShow }
					onChange={ postsToShow => { postsToShowUpdate( postsToShow ) } }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.review-carousel.post.limit', 15 ) }
					allowReset={ true }
					placeholder="6"
					className="czgb--help-tip-general-shadow"
				/>
				<RangeControl
					label={ __( 'Post Per Slide', i18n ) }
					value={ postperslide }
					onChange={ postperslide => setAttributes( { postperslide } ) }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.review-carousel.slide.limit', 6 ) }
					allowReset={ true }
					placeholder="6"
					className="czgb--help-tip-general-shadow"
				/>
				<RangeControl
					label={ __( 'Slide To Scroll', i18n ) }
					value={ slidesToScroll }
					onChange={ slidesToScroll => setAttributes( { slidesToScroll } ) }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.review-carousel.scroll.limit', 6 ) }
					allowReset={ true }
					placeholder="6"
					className="czgb--help-tip-general-shadow"
				/>
				<ToggleControl
					label={ __( 'Enable Box Shadow', i18n ) }
					checked={ displayboxShadow }
					onChange={ displayboxShadow => setAttributes( { displayboxShadow } ) }
				/>
			</PanelBody>
			<PanelBody title={ __( 'Display Settings', i18n ) } initialOpen={ true }>
				<ToggleControl
					label={ __( 'Enable Container', i18n ) }
					checked={ enableContainer }
					onChange={ enableContainer => setAttributes( { enableContainer } ) }
				/>
				<ToggleControl
					label={ __( 'Display Star Rating', i18n ) }
					checked={ displayStarRatings }
					onChange={ displayStarRatings => setAttributes( { displayStarRatings } ) }
				/>
				<ToggleControl
					label={ __( 'Display Section Header', i18n ) }
					checked={ displaySectionHeader }
					onChange={ displaySectionHeader => setAttributes( { displaySectionHeader } ) }
				/>
				<ToggleControl
					label={ __( 'Display Author Name', i18n ) }
					checked={ displayAuthorName }
					onChange={ displayAuthorName => setAttributes( { displayAuthorName } ) }
				/>
				<ToggleControl
					label={ __( 'Display Review Date', i18n ) }
					checked={ displayReviewDate }
					onChange={ displayReviewDate => setAttributes( { displayReviewDate } ) }
				/>
				<ToggleControl
					label={ __( 'Display Author Image', i18n ) }
					checked={ displayAuthorImage }
					onChange={ displayAuthorImage => setAttributes( { displayAuthorImage } ) }
				/>
			</PanelBody>
			<PanelBody title={ __( "Background Settings", i18n ) } initialOpen={ true }>
				<Fragment>
					<BackgroundSettings
						background={ background || 'bg-secondary' }
						backgroundColor={ backgroundColor }
						onChangeBackground={ background => setAttributes( { background, backgroundColor: '' } ) }
						onChangeBackgroundColor={ backgroundColor => setAttributes( { backgroundColor:backgroundColor.hex, background: '' } ) }
						onRemoveBackground={ () => { setAttributes( { background: '', backgroundColor: '' } ) } }
					/>
				</Fragment>
			</PanelBody>
		</Fragment>
	)
} )

const edit = props => {
	const { 
		attributes, 
		setAttributes,
		className,
		clientId,
	} = props

	const {
		blockId,
		postsToShow,
		postperslide,
		displayAuthorImage,
		displayAuthorName,
		displayReviewDate,
		enableContainer,
		displaySectionHeader,
		displayStarRatings,
		heading,
		backgroundColor,
		background,
		design,
		displayboxShadow,

		// Carousel
		slidesToShow,
		slidesToScroll,
		dots,
		arrows,
	} = attributes

	const slickEl = useRef(clientId)
	const setBlockId = blockId => setAttributes({blockId})

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'setOption', {
				slidesToShow: postperslide,
				slidesToScroll: slidesToScroll,
			}, true )
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'refresh' )
		} else if ( slickEl.current && $( slickEl.current ).find( '.js-slick-carousel' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel' ).slick()
			$( slickEl.current ).find( '.js-slick-carousel' ).slick('setOption', 'rtl', $('body,html').hasClass('rtl'), true );
            $( slickEl.current ).find( '.js-slick-carousel' ).slick( 'refresh' );
		}
	} )

	const mainClasses = classnames( [
		className,
		( design ==='style-1' && background !== undefined ) ? background : ( design ==='style-1' && 'bg-secondary' ),
		( design ==='style-2' && background !== undefined ) ? background : ( design ==='style-2' && 'bg-light' ),
	], applyFilters( 'cartzillagb.review-carousel.main-block.classes', {
		'pt-5 pb-300': design === 'style-1',
		'py-5 rounded-lg my-5 px-3 px-sm-4' : design === 'style-2',
	}, props ) )

	const containerClasses = classnames( [
		' py-md-5 mb-4 pt-3 pb-4',
		enableContainer ? 'container' : '',
	] )

	const cardClasses = classnames( [
		' card border-0',
		displayboxShadow ? 'box-shadow-sm' : '',
	] )

	let headingclass = 'text-center '

	if (design === 'style-1') {
		headingclass='mb-4 mb-md-5 pb-2'
	}
	if (design === 'style-2') {
		headingclass='h3 py-4'
	}

	const headingComp = (
		<RichText
			tagName='h2'
			className={ headingclass }
			value={ heading || 'Customer reviews' }
			onChange={ heading => setAttributes( { heading } ) }
			placeholder={ __( 'heading' ) }
			keepPlaceholderOnFocus
		/>
	)

	const styleAttr = {}

	styleAttr.style = {
		backgroundColor: backgroundColor && backgroundColor,
	}

	const content = range( 1, ( postsToShow ) + 1 ).map( i => {

		const increment = () => {
			setAttributes({ 
				[ `starRatings${ i }` ]: attributes[ `starRatings${ i }` ] + 1
			})
		}

		const decrement = () => {
			setAttributes({ 
				[ `starRatings${ i }` ]: attributes[ `starRatings${ i }` ] - 1 
			})
		}

		const starRatings = range( 1, 6 ).map( j => {
		
			let activeClass = ''

			if ( j <= attributes[ `starRatings${ i }` ] ) {
				activeClass = "-filled active"
			}

			return (
			   <i className={ `sr-star czi-star${ activeClass }` } key={ j }></i>
			)
		} )

		const review = attributes[ `review${ i }` ]
		const AuthorImage = attributes[ `authorImage${ i }` ]
		const AuthorName = attributes[ `authorname${ i }` ]
		const ReviewDate = attributes[ `reviewdate${ i }` ]

		let defaultauthorname = ''
		let defaultdate = ''

		if ( (i % 6 ) === 1 ) {
			defaultauthorname = __( 'Richard Davis', i18n )
			defaultdate = "Feb 14, 2020"
		}

		if ( (i % 6 ) === 2 ) {
			defaultauthorname = __( 'Laura Willson', i18n )
			defaultdate = "Feb 05, 2020"
		}

		if ( (i % 6 ) === 3 ) {
			defaultauthorname = __( 'Mary Alice Grant', i18n )
			defaultdate = 'Jan 27, 2020'
		}
		if ( (i % 6 ) === 4 ) {
			defaultauthorname = __( 'Rafael Marquez', i18n )
			defaultdate = 'Dec 19, 2020'
		}
		if ( (i % 6 ) === 5 ) {
			defaultauthorname = __( 'Adrian Lewis', i18n )
			defaultdate = 'Dec 13, 2020'
		}
		if ( (i % 6 ) === 0 ) {
			defaultauthorname = __( 'Daniel Adams', i18n )
			defaultdate = 'Dec 04, 2020'
		}

		const reviewComp = (
			<RichText
				value={ review || 'Lorem ipsum dolor sit amet, quia non consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.' }
				onChange={ review => setAttributes( { [ `review${ i }` ]: review } ) }
				placeholder={ __( 'review' ) }
				keepPlaceholderOnFocus
			/>
		)

		const authornameComp = (
			<RichText
				tagName='h6'
				className='font-size-sm mb-n1'
				value={ AuthorName || defaultauthorname }
				onChange={ AuthorName => setAttributes( { [ `authorname${ i }` ]: AuthorName } ) }
				placeholder={ __( 'AuthorName' ) }
				keepPlaceholderOnFocus
			/>
		)

		const reviewdateComp = (
			<RichText
				tagName='span'
				className='font-size-ms text-muted opacity-75'
				value={ ReviewDate || defaultdate }
				onChange={ ReviewDate => setAttributes( { [ `reviewdate${ i }` ]: ReviewDate } ) }
				placeholder={ __( 'ReviewDate' ) }
				keepPlaceholderOnFocus
			/>
		)

		const imageComp = (
			<ImageUploadPlaceholder
				imageURL={ AuthorImage }
				onRemove={ () => {
					setAttributes( {
						[ `authorImage${ i }` ]: '',
					} )
				} }
				onChange={ ( { url } ) => {
					setAttributes( {
						[ `authorImage${ i }` ]: url,
					} )
				} }
				hasRemove={ false }
				render={ 
					<img 
						src={ AuthorImage }
						width="50"
						className="rounded-circle"
						alt={ __( 'Author', i18n ) } 
					/> 
				}
			/>
		)

		const output = (
			<blockquote className="mb-2" key={ i }>
				<div className={ cardClasses }><span className="cz-testimonial-mark"></span>
					<div className="card-body font-size-md text-muted">
						<div className="mb-2">
							{ displayStarRatings &&
								<Fragment>
									{ attributes[ `starRatings${ i }` ] >= 1 && 
										<div className="star-rating">
											{ starRatings }
										</div>
									}
									<button type="button" disabled={ attributes[ `starRatings${ i }` ] === 5 ? 'disabled' : '' } className={ `btn btn-icon btn-primary btn-sm${ attributes[ `starRatings${ i }` ] === 5 ? ' disabled' : '' }` } onClick={ increment }>
										<span className="fas fa-plus btn-icon__inner"></span>
									</button>
									<button type="button" disabled={ attributes[ `starRatings${ i }` ] === 1 ? 'disabled' : '' } className={ `btn btn-icon btn-primary btn-sm ml-2${ attributes[ `starRatings${ i }` ] === 0 ? ' disabled' : '' }` } onClick={ decrement }>
										<span className="fas fa-minus btn-icon__inner"></span>
									</button>
								</Fragment>
							}
						</div>
					  { reviewComp }
					</div>
				</div>
				<footer className="d-flex justify-content-center pt-4">
					<div className="media align-items-center">
						{ displayAuthorImage && 
							imageComp
						}
						<div className="media-body pl-3">
							{ displayAuthorName &&
								authornameComp
							}
							{ displayReviewDate &&
								reviewdateComp
							}
						</div>
					</div>
				</footer>
			</blockquote>
		)
			
		return output
	} )

	const defaultCarouselOptions = applyFilters( 'cartzillagb.review-carousel.main-block.classes', {
		slidesToShow: 5,
		slidesToScroll: 5,
		dots: true,
		arrows: true,
		adaptiveHeight: true,
		prevArrow: '<i class="czi-arrow-left"></i>',
		nextArrow: '<i class="czi-arrow-right"></i>',
		customArrows: '.cz-custom-controls',
		speed: 500,
		pauseOnHover: true,
		responsive: [
			{
				breakpoint: 1198.98,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 991.98,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 575.98,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		],
	}, props )

	let carouselOptions = {
		slidesToShow: postperslide,
		slidesToScroll: slidesToScroll,
		dots: true,
		arrows: true,
		responsive: [
			{
				breakpoint: 1198.98,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 991.98,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 575.98,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		],
	}

	carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }

	const wraperAttr = {}

	wraperAttr.className = classnames( [
		'cz-carousel',
		'mb-3',
		arrows && 'cz-controls-outside',
	] )

	return (
		<Fragment>
			{ design === 'style-1' &&
				<section ref={ slickEl } id={ blockId || clientId } className={ mainClasses } { ...styleAttr }>
					<div className={ containerClasses }>
						<Fragment>
							{ displaySectionHeader &&
								headingComp
							}
						    <div { ...wraperAttr }>
								<div className="js-slick-carousel" data-slick={ JSON.stringify( carouselOptions ) }>
									{ content }
								</div>
							</div>
						</Fragment>
					</div>
				</section>			
			}
			{ design === 'style-2' &&
				<section ref={ slickEl } id={ blockId || clientId } className={ mainClasses } { ...styleAttr }>
					<Fragment>
							{ displaySectionHeader &&
								headingComp
							}
						  	<div { ...wraperAttr }>
								<div className="js-slick-carousel" data-slick={ JSON.stringify( carouselOptions ) }>
									{ content }
								</div>
							</div>
						</Fragment>
				</section>
			}
		</Fragment>
	)
}

export default compose(
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )